module.exports = __webpack_public_path__ + "static/media/background_img2.3ea6eeda.png";